<template>
  <UtilLoader :isLoading="!extension">
    <UtilImage
      v-if="fileExtensions.image.includes(extension)"
      @click="$emit('clickImage', fileRef)"
      :fileRef="fileRef"
      :width="appIs.retina ? 600 : 300"
      :targetClass="targetClass"
      :cover="imageCover"
      rounded
    />

    <div
      v-else
      @click="$emit('clickFile', compFullUrl)"
      class="file flex flex-col items-center justify-center h-full rounded bg-gray-lighter py-2 px-5"
    >
      <div class="text-xl">
        <FontAwesomeIcon v-if="fileExtensions.csv.includes(extension)" :icon="faFileCsv" />
        <FontAwesomeIcon v-else-if="fileExtensions.pdf.includes(extension)" :icon="faFilePdf" />
        <FontAwesomeIcon v-else-if="fileExtensions.document.includes(extension)" :icon="faFileWord" />
        <FontAwesomeIcon v-else-if="fileExtensions.spreadsheet.includes(extension)" :icon="faFileSpreadsheet" />
        <FontAwesomeIcon v-else-if="fileExtensions.video.includes(extension)" :icon="faFileVideo" />
        <FontAwesomeIcon v-else :icon="faFile" />

        <span class="ml-2">
          <span>.{{ extension }}</span>
        </span>
      </div>

      <div class="truncate text-sm max-w-full my-2">
        <span>{{ name }}</span>
      </div>

      <span class="underline text-brand">Download</span>
    </div>
  </UtilLoader>
</template>

<script>
import { fileExtensions } from '@/lib/file-types'
import {
  faFileCsv,
  faFilePdf,
  faFileSpreadsheet,
  faFile,
  faFileWord,
  faFileVideo
} from '@fortawesome/pro-light-svg-icons'
import UtilLoader from '@/components/utils/UtilLoader'
import UtilImage from '@/components/utils/UtilImage'

export default {
  name: 'UtilFile',
  components: {
    UtilLoader,
    UtilImage
  },
  props: {
    fileRef: String,
    name: String,
    extension: String,
    size: Number,
    imageCover: Boolean,
    targetClass: {
      type: String,
      default: 'rounded'
    }
  },
  data() {
    return {
      fileExtensions,
      faFileCsv,
      faFilePdf,
      faFileSpreadsheet,
      faFile,
      faFileWord,
      faFileVideo
    }
  },
  computed: {
    compFullUrl() {
      return fileExtensions.video.includes(this.extension)
        ? `${this.assetBaseUrl.video}${this.fileRef}`
        : `${this.assetBaseUrl.file}${this.fileRef}`
    }
  }
}
</script>
